<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Ajouter une énergie"
      updateLabel="Modifier une énergie"
    ></base-form-header>

    <mat-dialog-content class="flex items-center">
      <base-form-input
        label="PDL (point de livraison)"
        type="autocomplete"
        [items$]="energyIds$"
        (autocompleteChange)="energyIdsAutoCompleteChange($event)"
        displayProperty="energyIdId"
        controlName="energyIdId"
        [formGroup]="form"
        class="flex-1"
      ></base-form-input>

      <button
        *hasPermission="[ENUM_PERMISSION.UPDATE_BUILDING]"
        (click)="addEnergyId()"
        class="ml-4 mb-4"
        color="primary"
        mat-mini-fab
        matTooltip="Créer un nouvel id energy"
        type="button"
      >
        <mat-icon [icIcon]="icAdd"></mat-icon>
      </button>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        entityLabel="ENERGY"
        [loading]="loading"
        (onCreate)="createItem()"
        (onUpdate)="updateItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <div>Supprimer {{ data.name }}</div>
    <button type="button" mat-icon-button (click)="close(false)" tabindex="-1">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p>Etes-vous sûr de vouloir supprimer {{ data.name }} ?</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close(false)">NON</button>
    <button mat-button color="primary" (click)="deleteItem()">OUI</button>
  </mat-dialog-actions>
</ng-container>
